import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

import { LineLotTypes, LineLotInterface } from './types';
import { LineInterface } from '../lines/types';

// List Line Lot
export const listLineLotRequest = (payload: any) =>
  action(LineLotTypes.LIST_LINE_LOT_REQUEST, payload);

export const listLineLotSuccess = (payload: {
  lineLotList: LineLotInterface[];
  totalCount: number;
}) => action(LineLotTypes.LIST_LINE_LOT_SUCCESS, payload);

export const listLineLotFailure = () =>
  action(LineLotTypes.LIST_LINE_LOT_FAILURE);

// Get Line Lot
export const getLineLotRequest = (payload: any) =>
  action(LineLotTypes.GET_LINE_LOT_REQUEST, payload);

export const getLineLotSuccess = (payload: { lineLotData: LineLotInterface }) =>
  action(LineLotTypes.GET_LINE_LOT_SUCCESS, payload);

export const getLineLotFailure = () =>
  action(LineLotTypes.GET_LINE_LOT_FAILURE);

// Filter Line Lots
export const filterLineLotsRequest = (payload: object) =>
  asyncAction(LineLotTypes.FILTER_LINE_LOTS_REQUEST, payload);

export const filterLineLotsSuccess = () =>
  action(LineLotTypes.FILTER_LINE_LOTS_SUCCESS);

export const filterLineLotsFailure = () =>
  action(LineLotTypes.FILTER_LINE_LOTS_FAILURE);

// Create Line Lot
export const createLineLotRequest = (payload: any) =>
  action(LineLotTypes.CREATE_LINE_LOT_REQUEST, payload);

export const createLineLotSuccess = (payload: {
  lineLotData: LineLotInterface;
}) => action(LineLotTypes.CREATE_LINE_LOT_SUCCESS, payload);

export const createLineLotFailure = () =>
  action(LineLotTypes.CREATE_LINE_LOT_FAILURE);

// Add Line Lot
export const addLineLotRequest = (payload: any) =>
  action(LineLotTypes.ADD_LINE_LOT_REQUEST, payload);

export const addLineLotSuccess = (payload: { lineLotAdded: LineInterface }) =>
  action(LineLotTypes.ADD_LINE_LOT_SUCCESS, payload);

export const addLineLotFailure = () =>
  action(LineLotTypes.ADD_LINE_LOT_FAILURE);

// Update Line Lot
export const updateLineLotRequest = (payload: any) =>
  action(LineLotTypes.UPDATE_LINE_LOT_REQUEST, payload);

export const updateLineLotSuccess = () =>
  action(LineLotTypes.UPDATE_LINE_LOT_SUCCESS);

export const updateLineLotFailure = () =>
  action(LineLotTypes.UPDATE_LINE_LOT_FAILURE);

// Delete Line Lot
export const deleteLineLotRequest = (payload: any) =>
  action(LineLotTypes.DELETE_LINE_LOT_REQUEST, payload);

export const deleteLineLotSuccess = () =>
  action(LineLotTypes.DELETE_LINE_LOT_SUCCESS);

export const deleteLineLotFailure = () =>
  action(LineLotTypes.DELETE_LINE_LOT_FAILURE);
